import React from 'react';

function ResourcePrice({
  resource,
  className = '',
  variant = 'light',
}) {
  const compareLabel = resource.compareAtPriceLabel;
  const showCompare =
    compareLabel &&
    resource.compareAtPrice != null &&
    resource.compareAtPrice !== resource.price;

  const compareClassName =
    variant === 'dark' ? 'text-slate-500 line-through' : 'text-slate-400 line-through';
  const priceClassName =
    variant === 'dark' ? 'text-emerald-300 font-semibold' : 'text-emerald-700 font-semibold';

  return (
    <div className={`flex flex-wrap items-baseline gap-2 ${className}`}>
      {showCompare && (
        <span className={`text-sm ${compareClassName}`}>{compareLabel}</span>
      )}
      <span className={`text-sm ${priceClassName}`}>{resource.priceLabel}</span>
    </div>
  );
}

export default ResourcePrice;
